<form [formGroup]="optionsFormGroup">
  <mat-form-field
    class="ark-form-field ark-input-full-width ark-input-selector-chips"
    >
    <mat-label class="ark-mat-label">{{ title }}</mat-label>
    <mat-chip-grid
      #chipGrid
      aria-label="option selection"
      [required]="isValid"
      formControlName="optionsControls"
      >
      @for (option of optionsList; track $index; let i = $index) {
        @if (i < maxOptionsToShow) {
          <mat-chip-row
            [removable]="removable"
            (removed)="removeOption(option)"
            >
            @if (option.publicId === undefined) {
              <i
                class="fal fa-tag GA-toolbar-tags mr-2"
              ></i>
            }
            @if (getOptionText(option).length > 0) {
              <p
                class="ark-tag-text"
            matTooltip="{{
              getOptionText(option).length > 0 ? getOptionText(option) : ''
            }}"
                >
                {{ getOptionText(option) | slice: 0:23 }}
              </p>
            }
            @if (hasEdit) {
              <button (click)="onEditChip(option)">
                <mat-icon class="ark-edit-chip-action">create</mat-icon>
              </button>
            }
            @if (removable) {
              <button>
                <mat-icon matChipRemove>cancel</mat-icon>
              </button>
            }
          </mat-chip-row>
        }
      }
      @if (optionsList.length > maxOptionsToShow) {
        <div>
          <button mat-button (click)="showAllOptions()">
            <u>(+{{ optionsList.length - maxOptionsToShow }})</u>
          </button>
        </div>
      }
      <input
        class="ark-mat-label"
        appSelectorGeneralTabsButton
        [selectorGeneralTabs]="selectorChipsTabs"
        [readonly]="readonly"
        autocomplete="off"
        [matChipInputFor]="chipGrid"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="addOnBlur"
        />
        @if (hasUpdate) {
          <a mat-icon-button matSuffix class="ark-mat-icon-btn">
            <i class="fal fa-sync"></i>
          </a>
        }
      </mat-chip-grid>
      <mat-error>
        {{ 'error.Required' | translate }}
      </mat-error>
      @if (createElement) {
        <mat-hint align="end">
          <a
            class="ark-regular-link GA-message-create-add-topic"
            href="{{ createElement.Link }}"
            rel="noopener"
            target="_blank"
            >
            {{ createElement.Title }}
            <i
              class="fal fa-external-link-square fa-sm GA-message-create-add-topic"
            ></i>
          </a>
        </mat-hint>
      }
    </mat-form-field>
  </form>

  <app-selector-tabs
    #selectorChipsTabs
    [options]="selectorOptions"
    [generalOptions]="selectorGeneralOptions"
    (selectedChange)="onAddOption($event)"
    [_module]="_module"
    [excludedMediaType]="excludedMediaType"
    [mediaType]="mediaType"
    [locationId]="locationId"
    [version]="version"
    >
  </app-selector-tabs>
